import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { buildAetUserContext } from '../core/constant/user-context.util';

@Injectable({
  providedIn: 'root'
})
export class AddresolutionordersService {
  baseURL = environment.baseAPIURL;
  constructor( private readonly http  :HttpClient) { }

  setupResolutionWizard(resolutionId:any){
    return this.http
    .get(`${this.baseURL}/aet/setupResolutionWizard?resolutionId=${resolutionId}`,
    { responseType: 'json' })
    .pipe(catchError(this.handleError))
  }

  getResolutionOrders(resolutionId:any){
    return this.http.get(
      `${this.baseURL}/aet/getResolutionOrders?resolutionId=${resolutionId}`,
      { responseType: 'json' }
    )
      .pipe(catchError(this.handleError));
  }

  deleteResolutionOrders(selectedRemove:any[],eventId){
    //AFTER ORDER IDS RESOLUTION ID & GUID IS REQUIRED.
    let UrlOrder="";
    selectedRemove.forEach(value=>{
           UrlOrder=UrlOrder+value.orderId+',';
    })
    UrlOrder = UrlOrder.substring(0,UrlOrder.length - 1);
    return this.http.delete(
      `${this.baseURL}/aet/deleteResolutionOrder/${eventId}?orderIds=${UrlOrder}`,
      { responseType: 'text' }
    )
      .pipe(catchError(this.handleError));
  }

  getAllResolutionOrders(){
    return this.http.get(
      `${this.baseURL}/aet/getAllResolutionOrders`,
      { responseType: 'json' }
    )
      .pipe(catchError(this.handleError));
  }

  addResolutionOrders(addRequestBody,eventId){
    const rb = { event: addRequestBody, userReqDto: buildAetUserContext() };
    return this.http.post(`${this.baseURL}/aet/addResolutionOrders/${eventId}`, rb, { responseType: 'text' }).pipe(catchError(this.handleError));
  }
  findRouteDetails(responseBody:any){
    const rb = { event: responseBody, userReqDto: buildAetUserContext() };
    return this.http.post(`${this.baseURL}/aetDashBoard/aetEditOrders/findRouteDetails`, rb, { responseType: 'json' }).pipe(catchError(this.handleError));
  }
  getOwkOrders(gridResponseBody:any){
    const rb = { event: gridResponseBody, userReqDto: buildAetUserContext() };
    return this.http.post(`${this.baseURL}/aetDashBoard/aetEditOrders/getOwkOrders`, rb, { responseType: 'json' }).pipe(catchError(this.handleError));
  }
  getAllCanadaCode(){
    return this.http.get(`${this.baseURL}/aetHistory/getAllCanadaCode`, { responseType: 'json' })
      .pipe(catchError(this.handleError));
  }
  private handleError(error: HttpErrorResponse) {
		return throwError(error.message || "Server Error");
	}
}
